import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { lazy, Suspense } from "react";

const HRVHistoryPage = lazy(() => import("./HRVHistoryPage.tsx"));

function HRVHistoryPageLazy() {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HRVHistoryPage />
    </Suspense>
  );
}

export default HRVHistoryPageLazy;
